// pushUtils.ts
import { getFirebaseMessaging, VAPID_KEY } from "./firebase-config";
import { api } from "@/utils/api"; // your axios or fetch wrapper

export const initPushNotifications = async () => {
  try {
    if (typeof window === "undefined" || !("Notification" in window)) return;
    const messaging = await getFirebaseMessaging();
    if (!messaging) return;

    const permission = await Notification.requestPermission();
    if (permission !== "granted") return;
    const { getToken } = await import("firebase/messaging");
    const token = await getToken(messaging, { vapidKey: VAPID_KEY });
    console.log("the fcm token",token)
    if (token) {
      const payload = {token: token, deviceType: "web"}
      await api.saveFcmToken(payload); // your backend endpoint
      console.log("✅ FCM Token saved to backend:", token);
      localStorage.setItem('fcmToken',token)
    }
  } catch (err) {
    console.error("❌ FCM setup failed:", err);
  }
};

export const removeFcmTokenOnLogout = async () => {
  console.log("calling logout fcm token")
  try {
    const currentToken = localStorage.getItem("fcmToken");
   
    if (currentToken) {
      await api.removeFcmToken({ token: currentToken,deviceType: "web" });
      const messaging = await getFirebaseMessaging();
      if (messaging) {
        const { deleteToken } = await import("firebase/messaging");
        await deleteToken(messaging);
      }
      console.log("✅ FCM token deleted and removed from backend");
    }
  } catch (err) {
    console.error("❌ Failed to remove FCM token:", err);
  }
};

